import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import Point from '@arcgis/core/geometry/Point';
import Graphic from '@arcgis/core/Graphic';
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol"
import { Location } from '@angular/common';
import { FastAPIService, News, Solver } from 'src/app/service/fast-api.service';
import Basemap from "@arcgis/core/Basemap.js";
import { Subscription, lastValueFrom } from 'rxjs';
import { TreeNode } from 'primeng/api';
import Extent from '@arcgis/core/geometry/Extent';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})

export class NewsComponent {
  @Input() showMap: boolean = true;
  @Input() showRelated: boolean = true;
  @Input() showViews: boolean = true;
  @Input() preload: boolean = false;
  @Input() topic: string | null = null;
  @Input() detail: string | null = null;
  @Input() loading: boolean = true;
  @Input() showComment: boolean = false;
  @Input() comments: TreeNode[] = [];
  @Input() writer: string | null = null;
  @Input() images: string[] = [];
  @Input() source: string | null = null;
  @Input() showDetail: boolean = true;
  @Input() combinedWords: string[] = [];
  @Input() isFromSearch: boolean = false;

  latitude: number = 0;
  longitude: number = 0;
  constructor(private route: ActivatedRoute, private router: Router, private location: Location, private fastService: FastAPIService) {
    if (!this.preload) {
      this.routerSubscribe = this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd && event.url.split(';')[0] == '/news') {
          this.reloadNews();
        }
      });
    }
  }
  @ViewChild('mapPanel', { static: false }) mapPanel!: ElementRef;
  map: Map | null = null;
  mapView: MapView | null = null;
  point: Point[] = [];
  marker: PictureMarkerSymbol | null = null;
  pointGraphic: Graphic[] = [];
  id: string | null = "";
  disableState: boolean = false;
  relativeNewsNumber: number | null = 2;
  relative: News[] = [];
  news: News = new News();
  searchQuery: string = '';
  image: String[] = [];

  //highlightedLocations: string[] = [];

  filter = new Solver().solve().filter;

  routerSubscribe: Subscription | undefined;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.searchQuery = params['searchQuery'] || '';
      //console.log("Current searchQuery in NewsComponent:", this.searchQuery);
    });
  }

  onSegmentedWordsChange(words: string[]) {
    //console.log("Received Combined Words in NewsComponent:", words);
    this.combinedWords = words;
  }

  ngOnDestroy(): void {
    this.routerSubscribe?.unsubscribe();
  }

  async reloadNews() {
    if (this.preload) return;
    this.loading = true;
    this.id = this.route.snapshot.paramMap.get('id');

    this.isFromSearch = !!this.route.snapshot.queryParamMap.get('searchQuery');

    if (this.id) {
      try {
        const [historyResponse, newsResponse] = await Promise.all([
          lastValueFrom(this.fastService.saveHistory(this.id, 0)),
          this.fastService.searchWithLink(this.id)
        ]);
        this.news = newsResponse;
        // console.log(this.news);
        this.loading = false;

        if (this.news.Topic_OD) {
          console.log(this.news)
          console.log(typeof this.images, " before")
          this.images = Array.isArray(this.news.Picture_URL_OD) ? this.news.Picture_URL_OD : typeof this.news.Picture_URL_OD === 'string' ? [this.news.Picture_URL_OD] : []
          console.log("images!!", this.images)
          this.relative = (await this.fastService.getSearchResult(this.news.Topic_OD, 0, 5, "example")).newsList;
          await this.setCoordinate(this.news);
        }
      } catch (error) {
        console.error('Error loading news:', error);
        this.loading = false;
      }
    }


    await this.initializeMap();
  }

  async initializeMap() {
    const basemap = new Basemap({
      portalItem: {
        id: "bc19c34549de4000bcd91cef929420dc"
      }
    });

    this.map = new Map({
      basemap: basemap,
    });

    this.mapView = new MapView({
      container: this.mapPanel.nativeElement,
      map: this.map,
      center: [this.point[0]?.longitude ?? 100.501814, this.point[0]?.latitude ?? 13.754947],
      zoom: this.point[0] ? 13 : 7,
    });

    this.latitude = this.point[0]?.latitude ?? 100.501814;
    this.longitude = this.point[0]?.longitude ?? 13.754947;

    this.marker = new PictureMarkerSymbol({
      url: "assets/navbar-component-images/map-marker.svg",
      width: "46px",
      height: "58px"
    });

    this.pointGraphic = this.point.map(p => new Graphic({
      geometry: p,
      symbol: this.marker!
    }));

    this.mapView.graphics.removeAll();
    this.mapView.graphics.addMany(this.pointGraphic);

    this.mapView.on('click', () => {
      this.clickMap();
    });

    this.mapView.on("pointer-move", (event) => {
      const screenPoint = new Point({
        x: event.x,
        y: event.y,
        spatialReference: this.mapView?.spatialReference
      });

      const mapPoint = this.mapView?.toMap(screenPoint);
      this.latitude = mapPoint?.latitude!;
      this.longitude = mapPoint?.longitude!;
    });

    this.mapView.on("pointer-leave", () => {
      this.latitude = this.point[0]?.latitude ?? 13.754947;
      this.longitude = this.point[0]?.longitude ?? 100.501814;
    });

    await this.mapView.when();
    //this.mapView.goTo(this.pointGraphic);
    this.mapView.goTo({
      target: this.pointGraphic,
      zoom: 4
    })
  }


  goBack() {
    this.location.back();
  }

  async setCoordinate(res: any) {
    const latlong_list = res.LAT_LON_List
    this.point = [];
    if (latlong_list) {
      latlong_list.forEach((i: any) => {
        const latlong = i.split(',')
        this.point.push(new Point({
          latitude: parseFloat(latlong[0].trim()),
          longitude: parseFloat(latlong[1].trim())
        }))
      })
    }
    if (this.point.length > 0) {
      this.disableState = false;
    } else {
      this.disableState = true;
    }
  }

  clickRelativeNews(url: string) {
    this.isFromSearch = false;
    this.router.navigate(['/news', { id: url }]);
  }

  clickMap() {
    this.router.navigateByUrl(`/map;link=` + encodeURIComponent(this.id!))
  }
  /*extractHighlightedLocations(): void {
    if (this.news && this.news.LOCATION) {
      this.highlightedLocations = this.news.LOCATION;
    }*/

  getImageUrl(value: any): string {
  if (Array.isArray(value)) {
    return value[0] || this.fastService.getDefaultImage();
  }
  return value || this.fastService.getDefaultImage();
}

  onImageError (event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.fastService.getDefaultImage();
  }


}

